<template>
    <modal ref='import'>
        <template #header>
            <h5 class="modal-title mt-0">{{$t('tags.import_modal.import_tags')}}</h5>
        </template>

        <template #body>
            <form @submit.prevent='parseOrImportCSV($event)' @reset='clearImportData'>
                <div class="modal-body">
                    <div class="form-group">
                        <input type="file" name="file" class="form-control" accept="plain/text, text/csv" />
                    </div>

                    <p>
                        {{ $t('import_modal.download') }}
                        <a href="/tags-template.csv">
                            {{ $t('import_modal.a_sample_csv_template') }}
                        </a>
                        {{ $t('import_modal.to_see_an_example') }}
                    </p>

                    <div v-if='dataToImport.errors.length'>
                        {{$t('tags.import_modal.total_errors', {errors: dataToImport.errors.length })}}
                    </div>

                    <div v-if='dataToImport.errors.length'>
                        <ul>
                            <li v-for='error in dataToImport.errors.slice(0, 5)'>
                                {{ error }}
                            </li>
                        </ul>
                    </div>

                    <p v-if='dataToImport.progress'>
                        <strong>{{$t('tags.import_modal.progress')}}</strong>
                        {{ dataToImport.progress }}%
                    </p>

                    <p v-if='dataToImport.data.length'>
                        <strong>{{$t('tags.import_modal.total_tags')}}</strong>
                        {{ dataToImport.data.length }}
                    </p>

                    <table v-if='dataToImport.data.length' class="table">
                        <thead>
                        <th>{{$t('tags.import_modal.tag_name')}}</th>
                        </thead>

                        <tbody>
                        <tr v-for='row in dataToImport.data.slice(0, 5)'>
                            <td v-for='cell in row.slice(0, 1)'>
                                {{ cell }}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div  class='modal-footer'>
                    <input v-if='dataToImport.isParsing' type='reset' :value="$t('import_modal.reset')" class="btn btn-outline-primary">
                    <input v-if='dataToImport.progress === 100' type='submit' :value="$t('import_modal.import')" class="btn btn-primary">
                    <input v-else type='submit' :value="$t('import_modal.preview')" class="btn btn-primary">
                </div>
            </form>
        </template>
    </modal>
</template>

<script>
    import _modal from '../_modal'
    import Papa from 'papaparse'

    export default {
        components: {
            'modal': _modal,
        },
        data() {
            return {
                dataToImport: {
                    data: [],
                    errors: [],
                    progress: null,
                    isParsing: false
                }
            }
        },
        methods: {
            open() {
                this.$refs.import.open()
            },
            close() {
                this.clearImportData()
                this.$refs.import.close()
            },
            parseOrImportCSV(event) {
                if (this.dataToImport.progress === 100) {
                    this.importCSV()
                } else {
                    this.parseCSV(event)
                }
            },
            parseCSV(event) {
                let file = new FormData(event.target).get('file')

                if (file && file.size === 0)
                    return

                this.dataToImport.isParsing = true

                Papa.parse(file, {
                    worker: true,
                    skipEmptyLines: true,
                    step: (results) => {
                        this.dataToImport.data.push(Object.values(results.data))
                        this.dataToImport.progress = results.meta.cursor / file.size * 100
                        this.dataToImport.errors = results.errors.map(({message}) => message)
                    },
                    complete: () => {
                        this.dataToImport.progress = 100
                    }
                })
            },
            clearImportData() {
                this.dataToImport = {
                    data: [],
                    errors: [],
                    progress: null,
                    isParsing: false
                }
            },
            importCSV() {
                let params = { tags: this.dataToImport.data.map(([name]) => ({ name: name })) }

                this.store.createTagsBulk(params).then(({data}) => {
                  this.store.sendMetrics({name: 'import_tags_from_csv', params: this.$route.params, path: this.$route.fullPath})
                  this.store.getTags()

                    let message =  this.$t('tags.import_modal.we_imported', {resources: data.success})

                    if (data.failures > 0)
                        message += ", " + this.$t('tags.import_modal.but', {resources: data.failures})

                    this.$toastr.success(message)
                })

                this.close()
                this.$toastr.success(this.$t('tags.import_modal.started_importing'))
            }
        }
    }
</script>
